import React, { useState, useEffect } from 'react';

const PhotoRenderer = ({ photo, onClick }) => {
  const [isWide, setIsWide] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.onload = () => {
      const isWide = img.width / img.height > 1.1; // Wide if aspect ratio > 1.5
      setIsWide(isWide);
    };
    img.src = photo;
  }, [photo]);

  return (
    <img
      src={photo}
      alt="Complaint photo"
      className={isWide ? "wide-photo" : "complaint-photo"}
      onClick={() => onClick(photo)}
    />
  );
};

export default PhotoRenderer;
